import { i18n, TFunction } from 'next-i18next'
import { FilterProjectType, PosibleLocale, Project, ProjectKindType, ProjectOption, ProjectOptionNameType, VintageItemPayload } from '../models'

export const getProjectKind = (kind: ProjectKindType, t: TFunction) => {
  return {
    compensation: t('admin.Brokerage.Compensation'),
    contribution: t('admin.Brokerage.NBS'),
    energy: t('admin.Brokerage.Energy'),
    biodiversity: t('admin.Brokerage.Biodiversity'),
    carbon_forward: t('Forward.Title'),
  }[kind] || t('admin.Brokerage.Compensation')
}

export const getProjectUnit = (kind: ProjectKindType) => {
  return {
    compensation: 'tCO₂',
    contribution: 'UD',
    energy: 'MWh',
    biodiversity: 'CR'
  }[kind] || 'tCO₂'
}

export const getProjectUnitUd = (kind: ProjectKindType, t: TFunction, amount: number) => {
  if(kind === 'contribution' && amount > 1) return t('general.Uds')
  return {
    compensation: 'tCO₂',
    contribution: t('general.Ud'),
    energy: 'MWh',
    biodiversity: 'CR'
  }[kind] || 'tCO₂'
}

export const projectIsOutOfStock = (project: Project): boolean => {
  const balance = project?.is_vintage ? project?.get_vintage_items_available_sum_stock : project?.co2_balance
  return balance === 0
}


export const getVintageAvailableYears = (vintages: VintageItemPayload[], kind: ProjectKindType): number[] => {
  const isCarbonForward: boolean = kind === 'carbon_forward'
  const actualYear = new Date().getFullYear()
  const finalListAmount = isCarbonForward ? 15 : 10
  let customYear: number = isCarbonForward ? actualYear + 5 : actualYear
  const years: number[] = []
  while (years.length !== finalListAmount) {
    if (!vintages.some(vintage => +vintage.year === customYear)) {
      years.push(customYear)
    }
    customYear = customYear - 1
  }
  return years
}

export const getDescriptionLanguages = (t: TFunction): {
  locale: PosibleLocale, label: string
}[] => [
  { locale: 'en', label: t('Languages.English') },
  { locale: 'es', label: t('Languages.Spanish') },
  { locale: 'fr', label: t('Languages.French') },
  { locale: 'ko', label: t('Languages.Korean') },
  { locale: 'de', label: t('Languages.German') },
  { locale: 'pt', label: t('Languages.Portuguese') },
  { locale: 'it', label: t('Languages.Italy') },
  { locale: 'pl', label: t('Languages.Polish') },
  { locale: 'zh', label: t('Chinese') },
]


export const isHtmlTextEmpty = (value: string): boolean => {
  return value?.replaceAll(/<(.|\n)*?>/g, '')?.trim()?.length === 0
}


export const filteredOptions = (projectOptions: ProjectOption[], type: ProjectOptionNameType) => {
  return projectOptions.filter(po => po.name === type)
}

export const getProjectOptionName = (projectOption: ProjectOption, defaultLang=false) => {
  if (defaultLang){
    return projectOption.value_en
  }
  if (!projectOption[`value_${i18n.language}`]?.trim()) {
    return projectOption.value
  }
  return projectOption[`value_${i18n.language}`].trim()
}

export const getVintageAvailableStock = (project: Project): number => {
  return project.vintage_items.reduce((a, vintage) => a + vintage.stock_balance, 0)
}

export const getProjectsFiltered = (
  filters: {text: string, type: FilterProjectType}, projects: Project[]
): Project[] => {
  let newProjectList = projects

  if (filters.text && filters.text?.trim()?.length !== 0) {
    const text = filters.text.toLowerCase()
    newProjectList = newProjectList.filter((project: Project)=> project.name.toLowerCase().includes(text))
  }

  if (filters.type !== 'ALL') {
    const value = filters.type
    if (value === 'VINTAGE') { newProjectList = newProjectList.filter((p)=> p.is_vintage ) }
    else { { newProjectList = newProjectList.filter((p)=> !p.is_vintage ) }}
  }

  return newProjectList
}

export const getProjectHeadline = (project: Project): string => {
  return project[`headline_${i18n.language}`] || project?.headline
}
